import { Dialog } from "radix-ui";
import RemoveIcon from "../../atoms/images/RemoveIcon";

export default function DialogHeader({ showClose = true }) {
  return showClose ? (
    <Dialog.Close className="absolute right-4 top-4 text-gray-500 hover:text-black">
      <RemoveIcon />
    </Dialog.Close>
  ) : null;
}
